<template>
    <appInvoice
        :company="company"
        :customer="customer"
        :invoice="invoice"
        :variant="1"
        currency="usd"
    />
</template>

<script>
import appInvoice from '@/components/Invoice/Invoice.vue';
import { getAwsAccountInvoice } from '@/services/aws.service';
const awsRegions = require('aws-regions');

export default {
    name: 'InvoiceView',
    components: {
        appInvoice,
    },
    data() {
        return {
            company: {
                name: 'DGG Cloud',
                address:
                    '1 Syed Alwi Road #04-04 Song Lin Building, Singapore 207628',
            },
            invoice: {
                id: '',
                items: [],
                dueDate: '',
            },
            customer: {
                name: 'Stefan Doe',
                email: '',
                description: 'AWS Usage',
            },
            //logo: '',
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const { accountId, year, month } = this.$route.params;
            // Check id is existed
            if (!accountId || !year || !month) {
                this.$router.push({ name: 'home' });
            }
            this.isLoading = true;
            this.$store.commit('loading/setLoading', true);
            console.log(accountId + ' ' + year + ' ' + month);
            getAwsAccountInvoice(accountId, year, month)
                .then(({ data }) => {
                    const groupedData = {};
                    data['Items'].forEach((item) => {
                        const regionObj = awsRegions.lookup({
                            code: item['product_region'],
                        });
                        const region = regionObj
                            ? regionObj.full_name
                            : item['product_region'];
                        const product_region = item['product_region']
                            ? region
                            : 'Others';
                        const product_product_name =
                            item['product_product_name'];

                        if (!groupedData[product_product_name]) {
                            groupedData[product_product_name] = {};
                        }
                        if (
                            !groupedData[product_product_name][product_region]
                        ) {
                            groupedData[product_product_name][product_region] =
                                [];
                        }
                        groupedData[product_product_name][product_region].push(
                            item
                        );
                    });
                    console.log(groupedData);
                    this.invoice.items = groupedData;
                    this.$store.dispatch('addInvoice', this.invoice);
                    this.customer.name = data['awsAccountName'];
                    this.customer.email = data['awsAccountId'];
                    this.$store.dispatch('addCustomer', this.customer);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$store.commit('loading/setLoading', false);
                });
        },
    },
};
</script>
